module.exports = __webpack_public_path__ + "static/media/renato_galvao_da_silveira_mussi.f6ff8be7.jpg";